import { Icon } from "@iconify/react";
import { memo } from "react";
import { Colors } from "../../utils/colors";

type DragDropListIconProp = {
  dragHandleProps: any;
  size?: number;
};

const DragDropListIcon = memo(function DragDropListIconFn(
  props: DragDropListIconProp
) {
  const { dragHandleProps, size = 27 } = props;

  return (
    <div {...dragHandleProps} style={{ cursor: "grab" }}>
      <Icon
        icon={"ion:menu-outline"}
        height={size}
        style={{ color: Colors.GRAY1 }}
      />
    </div>
  );
});

export default DragDropListIcon;
